import axios from 'axios';

import { AllBrandPayouts, AllMerchantPayouts, MpsDocumentsDossier } from './types';
import { VenuePayout } from './types';

const merchantPayoutServiceApi = axios.create({
  baseURL: process.env.MERCHANT_PAYOUT_SERVICE_URI,
});

export default merchantPayoutServiceApi;

export const fetchSalesReportList = (venueId: string) =>
  merchantPayoutServiceApi
    .get<VenuePayout[]>(`/public/v1/merchant-admin/venues/${venueId}/payouts`)
    .then(response => response.data);

export const getMpsDocumentDossier = (venueId: string, payoutId: string) =>
  merchantPayoutServiceApi
    .get<MpsDocumentsDossier>(`/public/v1/merchant-admin/payouts/${venueId}/${payoutId}/dossier`)
    .then(response => response.data.documents.filter(document => document.status === 'RENDERED'));

export const getMpsDocument = (venueId: string, payoutId: string, documentId: string) =>
  merchantPayoutServiceApi
    .get<Blob>(`/public/v1/merchant-admin/payouts/${venueId}/${payoutId}/documents/pdf?document_id=${documentId}`, {
      responseType: 'arraybuffer',
    })
    .then(response => response);

export const fetchMPSInvoiceDossierInZip = (venueId: string, payoutId: string) =>
  merchantPayoutServiceApi.get<Blob>(`/public/v1/merchant-admin/payouts/${venueId}/${payoutId}/documents/zip`, {
    responseType: 'arraybuffer',
  });

export const getAllMerchantPayouts = (merchantId: string): Promise<AllMerchantPayouts> =>
  merchantPayoutServiceApi.get(`/public/v1/merchant-payouts/${merchantId}`).then(response => {
    return {
      ...response.data,
      payouts: response.data.payouts.data,
    };
  });

export const getCombinedMerchantPayoutReport = (merchantId: string, merchantPayoutId: string) =>
  merchantPayoutServiceApi.get<Blob>(`/public/v1/merchant-payouts/archive/${merchantId}/${merchantPayoutId}`, {
    responseType: 'arraybuffer',
  });

export const fetchMPSVenuePayoutInCsv = (venueId: string, payoutId: String, isMpsPayout: boolean) =>
  merchantPayoutServiceApi.get<Blob>(`/public/v1/merchant-admin/venues/${venueId}/payouts/documents/csv`, {
    params: {
      [isMpsPayout ? 'payout_id' : 'payout_number']: payoutId,
    },
    responseType: 'arraybuffer',
  });

export const getAnnualReportCsv = (venueId: string, year: number) =>
  merchantPayoutServiceApi.get(`/public/v1/merchant-admin/venues/${venueId}/payouts/annual-report/${year}/csv`);

export const getAllBrandPayouts = (brandId: string): Promise<AllBrandPayouts> =>
  merchantPayoutServiceApi.get(`/public/v1/brand-payouts/${brandId}`).then(response => {
    return {
      ...response.data,
      payouts: response.data.payouts.data,
    };
  });

export const getCombinedBrandPayoutReport = (brandId: string, brandPayoutId: string) =>
  merchantPayoutServiceApi.get<Blob>(`/public/v1/brand-payouts/archive/${brandId}/${brandPayoutId}`, {
    responseType: 'arraybuffer',
  });
